import { translate } from 'src/app/project/features/translate/translate';
import { EImportCustomFieldError } from './import-custom-fields.consts';

const ERROR_CODE_SEPARATOR = ':';

export type TImportCustomFieldError = {
  code: EImportCustomFieldError;
  detail: string;
};

export function parseImportCustomFieldError(errorMessage: string): TImportCustomFieldError {
  const [code, ...rest] = (errorMessage ?? '').split(ERROR_CODE_SEPARATOR);

  return {
    code: code.trim() as EImportCustomFieldError,
    detail: rest.join(ERROR_CODE_SEPARATOR).trim(),
  };
}

export function getImportCustomFieldError(errorMessage: string): string {
  const { code, detail } = parseImportCustomFieldError(errorMessage);

  switch (code) {
    case EImportCustomFieldError.CFT_IMPORT_SAME_SITE:
      return translate('cf_import_same_site_error');
    case EImportCustomFieldError.CFT_IMPORT_DUPLICATE_SOURCE:
      return translate('cf_import_duplicate_source_error');
    case EImportCustomFieldError.CFT_IMPORT_UNKNOWN_FIELD:
      return translate('cf_import_unknown_field_error');
    case EImportCustomFieldError.CFT_IMPORT_UNKNOWN_GROUP:
      return translate('cf_import_unknown_group_error');
    case EImportCustomFieldError.CFT_IMPORT_FIELD_NOT_IN_GROUP:
      return translate('cf_import_field_not_in_group_error');
    case EImportCustomFieldError.CFT_IMPORT_DUPLICATE_FIELD:
      return translate('cf_import_duplicate_field_error');
    case EImportCustomFieldError.CFT_IMPORT_GROUP_INTO_GROUP:
      return translate('cf_import_group_into_group_error');
    case EImportCustomFieldError.CFT_IMPORT_NAME_CONFLICT:
      return detail
        ? translate('cf_import_name_conflict_field_error', { fieldName: detail })
        : translate('cf_import_name_conflict_error');
    case EImportCustomFieldError.CFT_IMPORT_VOLY_INTEGRATION:
      return translate('cf_import_voly_integration_error');
    case EImportCustomFieldError.CFT_IMPORT_TIMELINE_LIMIT:
      return translate('cf_import_timeline_limit_error');
    case EImportCustomFieldError.CFT_IMPORT_TIMELINE_FEATURE:
      return translate('cf_import_timeline_feature_error');
    case EImportCustomFieldError.CFT_IMPORT_FORMULA_ERROR:
      return '';
    case EImportCustomFieldError.CFT_IMPORT_FORMULA_NESTING:
      return translate('cf_import_formula_nesting_error');
    default:
      return translate('prompt_error');
  }
}
